<script>
import options from './StafetDeltagSomFighterStepThree.options'
export default options
</script>

<template>
  <article
    class="kb-stafet-step kb-stafet-deltag-som-fighter-step-three kb-optimizely-forms"
  >
    <div>
      <h2 class="kb-stafet-step__title">
        {{ labels.fighterJoinHoldTitle }}
      </h2>
      <p class="kb-stafet-step__description">
        {{ labels.fighterJoinHoldDescription }}
      </p>
    </div>

    <div class="kb-stafet-step__input-wrapper">
      <FormCheckbox
        fieldName="joinATeam"
        :modelValue="joinATeam.toString()"
        v-model="joinATeam"
        :label="labels.fighterJoinHoldCheckboxLabel"
        :errorMessageLabel="labels.fighterJoinHoldCheckboxErrorMessage"
        :onChangeCallback="(e) => setJoinATeam(e.target.checked)"
      />

      <FormCheckbox
        fieldName="isChild"
        :modelValue="isChild.toString()"
        v-model="isChild"
        :label="labels.fighterIsChildCheckboxLabel"
        :onChangeCallback="(e) => setIsChild(e.target.checked)"
      />

      <FormInputDropdown
        v-if="joinATeam"
        :modelValue="teamName"
        v-model="teamName"
        :label="labels.fighterJoinHoldDropdownLabel"
        :placeholder="labels.fighterJoinHoldDropdownLabel"
        :isRequired="true"
        fieldName="teamName"
        :selectOptions="teams"
        :onChangeCallback="(e) => validateField('teamName', e.target.value)"
        :errorMessageLabel="labels.fighterJoinHoldDropdownErrorMessage"
        :isValidationError="handleErrorMessage('teamName')"
      />

      <FormCheckbox
        v-if="joinATeam"
        fieldName="newsletter"
        :modelValue="newsletter.toString()"
        v-model="newsletter"
        :label="labels.yourInformationNewsletterBoolLabel"
        :onChangeCallback="(e) => validateField('newsletter', e.target.checked)"
      />
    </div>

    <StafetPayment
      :title="labels.fighterJoinHoldTotalTitle"
      :basket="basket"
      :inTotalLabel="labels.fighterJoinHoldTotal"
      :inTotalPrice="basketTotalPrice.toString()"
    />

    <StafetActions
      :nextStepCallback="() => nextStepCallback(stepModel)"
      :nextStepLabel="labels.formNavigationLastStep"
      :previousStepCallback="previousStepCallback"
      :previousStepLabel="labels.formNavigationPreviousStep"
    />
  </article>
</template>
